import { FC } from 'react';
import { CellEntityTypeProps } from './CellEntityType.types';
import { Flex, CellContainer, Pill, Text, Tooltip } from '@/_components';

export const CellEntityType: FC<CellEntityTypeProps> = ({ company }) => {
  const isIndividual: boolean = company?.entity_type === 'Individual';

  return (
    <CellContainer>
      <Flex isInline={true}>
        <Tooltip isDisabled={!company?.inactive}>
          <Tooltip.Content>
            <Text type="tiny" color="currentcolor">
              Inactive
            </Text>
          </Tooltip.Content>
          <Tooltip.Trigger>
            <Pill
              label={company?.entity_type || 'Empty'}
              isRound={true}
              iconLeft={isIndividual ? 'user-circle' : 'briefcase'}
              intent={company?.inactive ? 'danger' : 'secondary'}
            />
          </Tooltip.Trigger>
        </Tooltip>
      </Flex>
    </CellContainer>
  );
};
